import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setPayrolls } from "../actions";
import service from "../services/paymentPartnersService";
import PayrollList from "../components/PayrollList.jsx";

class Payrolls extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        
        this.getPayrolls = () => {
            const { recruiterId, selectedStartDate, selectedFinalDate } = this.props;
            return service.getPayrolls(recruiterId, selectedStartDate.format('YYYY-MM-DD'), selectedFinalDate.format('YYYY-MM-DD'))
                .then(res => {
                    const response = res.data;
                    this.props.setPayrolls(response.payrolls);
                })
                .catch(error => console.log(error))
        };
        
        this.deletePayroll = (payrollId) => {
            return service.deletePayroll(payrollId)
                .then(res => {
                    this.getPayrolls()   
                })
                .catch(error => console.log("ocurrió un error"))
        }
    };
    
    componentDidMount(){
        this.getPayrolls();
    }
    
    render() {
        return(
            <PayrollList 
                payrolls={this.props.payrolls} 
                deletePayroll={this.deletePayroll} 
                getPayrolls={this.getPayrolls}
            />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        payrolls: state.payrollState.payrolls,
        selectedStartDate: state.dateState.selectedStartDate,
        selectedFinalDate: state.dateState.selectedFinalDate,
        recruiterId: state.partnerState.recruiterId
    }
};

const mapDispatchToProps = {
    setPayrolls
};

export default connect(mapStateToProps, mapDispatchToProps)(Payrolls);


// WEBPACK FOOTER //
// ./frontEnd/treasury/payment-partners/containers/Payrolls.jsx